import { useState } from "react";

export const TIME_DISPLAY_FORMAT_KEY = "ui-time-display-format";
export const DURATION_DISPLAY_FORMAT_KEY = "ui-duration-display-format";
export type TimeDisplayFormat = "compact" | "alternate";
export type DurationDisplayFormat = "compact" | "alternate";

export function readTimeDisplayFormat(): TimeDisplayFormat {
  if (typeof window === "undefined") return "compact";
  return window.localStorage.getItem(TIME_DISPLAY_FORMAT_KEY) === "alternate" ? "alternate" : "compact";
}

export function readDurationDisplayFormat(): DurationDisplayFormat {
  if (typeof window === "undefined") return "compact";
  return window.localStorage.getItem(DURATION_DISPLAY_FORMAT_KEY) === "alternate" ? "alternate" : "compact";
}

export function useTimeDisplayFormat() {
  const [format, setFormat] = useState<TimeDisplayFormat>(readTimeDisplayFormat);
  return { format, setFormat };
}

export function useDurationDisplayFormat() {
  const [format, setFormat] = useState<DurationDisplayFormat>(readDurationDisplayFormat);
  return { format, setFormat };
}

export function formatMinutesForDisplay(minutes: number, format: TimeDisplayFormat) {
  if (format === "compact") return `${minutes}m`;
  const hours = Math.floor(minutes / 60);
  const remaining = minutes % 60;
  if (!hours) return `${remaining}m`;
  if (!remaining) return `${hours}h`;
  return `${hours}h ${remaining}m`;
}

export function formatTimeForDisplay(minutes: number, format: TimeDisplayFormat) {
  if (format === "compact") return `${String(Math.floor(minutes / 60)).padStart(2, "0")}:${String(minutes % 60).padStart(2, "0")}`;
  const hour12 = Math.floor((minutes % (12 * 60)) / 60) || 12;
  return `${hour12}:${String(minutes % 60).padStart(2, "0")} ${minutes < 12 * 60 ? "AM" : "PM"}`;
}

export function alternateTimeFormat(format: TimeDisplayFormat): TimeDisplayFormat {
  return format === "compact" ? "alternate" : "compact";
}
